import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, PropType, computed, reactive, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ParamCodeParams } from '@/typings/common'
import { listByParamCodes } from '@/api/common'
import Modal from '@/hooks/modalType'
import { DcMessage } from '@dc-platform/dc-components'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { clueAndcustomerPhaseEnum as fbuClueAndcustomerPhaseEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { clueAndcustomerPhaseEnum as ofbuClueAndcustomerPhaseEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { clueAndcustomerPhaseEnum as lbuClueAndcustomerPhaseEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import type { FbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import BusinessName from '@/components/BusinessName/index.vue'
import request from '@/utils/request'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'OperationLog' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  clueCosId: String,
  disabled: {
    type: Boolean,
    default: true
  },
  appId: {
    type: String as PropType<ParamCodeParams['appId']>,
    default: 'cos_fbu'
  },
  permissionPage: {
    type: Object as PropType<{
      edit: string
      del: string
      comment?: string
    }>,
    default: () => {
      return {}
    }
  },
  showFooter: {
    type: Boolean,
    default: false
  },
  workCode: {
    // 线索负责人
    type: String
  },
  followRefId: String, //  线索客户id
  chanceId: String // 商机id
},
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const tableRef = ref()
const props = __props
const paramCodeData = reactive<{
  follow_mode: []
  follow_purpose: []
}>({
  follow_mode: [], // 拜访方式
  follow_purpose: [] // 访客目的
})
const appIdEumn = computed(() => {
  return eumn[props.appId]
})
const eumn = {
  cos_fbu: 'fbu',
  cos_lbu: 'lbu',
  cos_zbu: 'zbu',
  cos_ofbu: 'ofbu'
}
const dataConfigEnum = {
  cos_fbu: fbuClueAndcustomerPhaseEnum,
  cos_ofbu: ofbuClueAndcustomerPhaseEnum,
  cos_lbu: lbuClueAndcustomerPhaseEnum
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: props.appId,
    paramCodes: [`${appIdEumn.value}_follow_mode`, `${appIdEumn.value}_follow_purpose`]
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.follow_mode = res.data[`${appIdEumn.value}_follow_mode`]
      paramCodeData.follow_purpose = res.data[`${appIdEumn.value}_follow_purpose`]
    }
  })
}
const fetch = async (params: object, callBack: (res: any) => void) => {
  request
    .post(`${appIdEumn.value}/api/followRecords/page`, {
      ...params,
      chanceId: props.chanceId,
      followRefId: props.followRefId
    })
    .then((res) => {
      callBack(res)
    })
}
// 详情
const handleDetail = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: `/${appIdEumn.value}/followUpRecord/view`,
    query: {
      id: record.id
    }
  })
}
// 删除
const handleDel = (record: FbuFollowUpRecordItem) => {
  loading.value = true
  Modal.delete({
    async onOk() {
      if (record.id) {
        request.delete(`${appIdEumn.value}/api/followRecords/${record.id}`).then((res) => {
          DcMessage.success(t('tips.delSuccess'))
          tableRef.value.delFetch()
          loading.value = false
        })
      }
    }
  })
}

// 编辑
const handleEdit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: `/${appIdEumn.value}/followUpRecord/edit`,
    query: {
      id: record.id,
      returnPath: route.fullPath
    }
  })
}
// 评论
const handleCommit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: `/${appIdEumn.value}/followUpRecord/commit`,
    query: {
      id: record.id,
      returnPath: route.fullPath
    }
  })
}
const columns = computed(() => {
  if (props.appId === 'cos_fbu' || props.appId === 'cos_ofbu') {
    return [
      {
        title: t('follow.stage'),
        dataIndex: 'stage',
        dicData: dataConfigEnum[props.appId]
      },
      { title: t('follow.purpose'), dataIndex: 'fbuPurpose', dicData: paramCodeData.follow_purpose },
      { title: t('follow.fllowTime'), dataIndex: 'startTime', width: 310 },
      { title: t('follow.createByName'), dataIndex: 'createByName' },
      { title: t('follow.customerContactName'), dataIndex: 'contactName', width: 150 },
      { title: t('follow.dutyByName'), dataIndex: 'dutyByName' },
      { title: t('follow.preCustomerName'), dataIndex: 'preFollowRefName' },
      { title: t('follow.processDetail'), dataIndex: 'process', width: 450 },
      {
        title: t('common.action'),
        dataIndex: 'action',
        fixed: 'right',
        langWidth: {
          zh: 220,
          en: 310
        }
      }
    ]
  } else {
    return [
      {
        title: '客户名称',
        dataIndex: 'customerName',
        fixed: 'left'
      },
      { title: '客户阶段', dataIndex: 'stage', dicData: dataConfigEnum[props.appId] },
      { title: '联系人姓名', dataIndex: 'contactName' },
      { title: '关联商机', dataIndex: 'chanceName' },
      { title: '目的', dataIndex: 'lbuPurpose' },
      { title: '跟进过程', dataIndex: 'process' },
      { title: '结果/后续', dataIndex: 'result' },
      { title: '当前遇到的问题', dataIndex: 'problem', width: 210 },
      { title: '跟进人', dataIndex: 'dutyByName', width: 100 },
      { title: '跟进方式', dataIndex: 'mode', dicData: paramCodeData.follow_mode },
      { title: '跟进时间', dataIndex: 'startTime', width: 310 },
      { title: '创建人', dataIndex: 'createByName', width: 190 },
      { title: '创建时间', dataIndex: 'createTime', width: 190 },
      { title: '操作', dataIndex: 'action', fixed: 'right', width: 220 }
    ]
  }
})
onMounted(() => {
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    serial: "",
    rowKey: "id",
    onFetch: fetch,
    ref_key: "tableRef",
    ref: tableRef,
    tableId: `${_unref(route).path}_TabsClueCosFollowUp`
  }, {
    bodyCell: _withCtx(({ column, record, text }) => [
      (column.dataIndex === 'startTime')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text) + "~" + _toDisplayString(record.endTime), 1))
        : _createCommentVNode("", true),
      (column.dataIndex === 'chanceName')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            text
              ? (_openBlock(), _createBlock(BusinessName, {
                  key: 0,
                  appId: __props.appId,
                  value: text
                }, null, 8, ["appId", "value"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_2, "--"))
          ], 64))
        : _createCommentVNode("", true),
      (column.dataIndex === 'process')
        ? (_openBlock(), _createBlock(EditorTableText, {
            key: 2,
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'action')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (handleDetail(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.detail')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (handleDel(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, __props.permissionPage?.del]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (handleEdit(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, __props.permissionPage?.edit]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (handleCommit(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.comment')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, props.appId === 'cos_lbu' ? 'lbu_follow_comment_btn' : __props.permissionPage?.comment]
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})